import { default as SelectedItems } from './SelectedItems'
export default SelectedItems
